import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecords } from '../api.service';

const IdleService = ({ logoutCallback }) => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [data, setData] = useState(null);

    const idleTimeLimit = 30 * 60 * 1000; // 30 minutes

    const getData = async () => {
        try {
            const authUser = JSON.parse(localStorage.getItem("authUser"));

            if (!authUser || !authUser.vendor_masters?.id) {
                console.error("No vendor_id found in localStorage");
                return;
            }

            const vendorId = authUser.vendor_masters.id;

            let payload = {
                modelName: "vendor_masters",
                whereCondition: {
                    id: vendorId,
                },
            };

            const responseData = await getRecords('/common/getRecords', payload);

            if (responseData.data && responseData.data.length > 0) {
                const vendorData = responseData.data[0];
                console.log("data===>", vendorData);
                setData(vendorData);

                // ✅ Check active status
                if (vendorData.is_active === 0 || vendorData.is_active === "0") {
                    console.warn("Vendor is inactive. Logging out...");
                    await logoutCallback();
                    navigate('/logout');
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const events = ['click', 'mousemove', 'keypress', 'touchstart'];

        const resetTimer = () => {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                handleIdle();
            }, idleTimeLimit);
        };

        const handleIdle = async () => {
            console.log('User idle for 30 minutes. Logging out...');
            try {
                await logoutCallback(); 
            } catch (error) {
                console.error('Error during idle logout:', error);
            }
            navigate('/logout'); 
        };

        getData(); // 🔹 Check vendor status on mount

        events.forEach((event) => window.addEventListener(event, resetTimer));
        resetTimer(); 

        return () => {
            clearTimeout(timeoutRef.current);
            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
        };
    }, [logoutCallback, navigate]);

    return null; 
};

export default IdleService;
